module.exports = __webpack_public_path__ + "static/img/qingchen.178dcde1.jpg";